import React from 'react';
import { Button, Divider, Avatar, Typography } from 'antd';
import { FaMapMarkerAlt, FaPhone, FaLocationArrow } from 'react-icons/fa';
import moment from 'moment';
import _ from 'lodash';
import i18n from 'i18next';

import { Orders } from '../../../store/orders/types';
import { GlobalModalHandler, GlobalModalClose } from '../../layout/GlobalModal';
import Map from './Map';

import LikeIcon from '../../../assets/images/png/like.png';

interface OrderAcceptedProps {
  order: Orders;
  navigate: Function;
}

export const OrderAccepted = ({ order, navigate }: OrderAcceptedProps) => {
  const { cookDetails, consumptiondate } = order;
  const seconds = _.get(consumptiondate, 'seconds');
  const orderdatetime = moment.unix(seconds).format('HH:mm');

  const handleContinueBtn = () => {
    GlobalModalClose();
    navigate();
  };

  return (
    <div>
      <div className="modal-content-wrapper">
        <div className="modal-content-icon">
          <img src={LikeIcon} alt="modal-content-icon" />
        </div>
        <div className="modal-content-description">
          <span>{i18n.t('ACCEPTED_ORDER')}</span>
          <div className="modal-content-extra-text margin-top">
            {i18n.t('PICKUP_ADDRESS')}{' '}
            <Typography.Text strong>{orderdatetime}.</Typography.Text>
          </div>
        </div>
      </div>
      <Divider />
      <div className="modal-content-wrapper order-accepted-container">
        <div>
          <Avatar src={cookDetails?.image} />
        </div>
        <div className="accepted-cook-details">
          <span className="cook-details-name">{cookDetails?.firstName}</span>
          <div className="cook-details-address">
            {`${cookDetails?.address.street} - ${cookDetails?.address.city}`}
          </div>
        </div>
        <div className="accepted-cook-contact">
          <div>
            <FaPhone size={14} />
            <span>{cookDetails?.phone}</span>
          </div>
          <div>
            <FaMapMarkerAlt size={14} color={'#A8A8A8'} />
            <span className="cook-distance">1,3 km</span>
          </div>
        </div>
      </div>
      <div className="order-map-container">
        <Map order={order} />
        <div className="button-container modal-map-buttons-container button-container-absolute">
          <div>
            <Button block shape="round" className="navigate-button">
              <FaLocationArrow size={12} color="#547ce6" />
              <span>{i18n.t('NAVIGATE')}</span>
            </Button>
          </div>
          <div>
            <Button
              block
              shape="round"
              className="continue-button continue-button-primary"
              onClick={handleContinueBtn}
            >
              <span className="continue-button-text">{i18n.t('Continue')}</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export const orderAcceptedModalHandler = (
  meal: Orders,
  navigate: (e?: React.MouseEvent) => void
) => {
  GlobalModalHandler({
    content: <OrderAccepted order={meal} navigate={navigate} />,
  });
};
